<template>
    <div class="devices-list__block" v-if="deviceData" @click="openLightingHistory">
        <device-status :device="deviceData" :showLocation="showLocation"/>
        <v-layout row class="devices-list__block__title">
            <device-title :device="deviceData"></device-title>
            <v-flex class="btn-block">
                <device-favorite :device="deviceData" @click.stop.prevent></device-favorite>
                <div class="d-inline-flex" v-if="deviceData.state != null && deviceData.online" @click.stop.prevent>
                    <v-switch
                        v-model="deviceData.state.value"
                        inset
                        dense
                        hide-details
                        class="pa-0"
                        @click="changeDeviceState"
                        :loading="loading"
                        color="#FF8484"
                        :disabled="deviceData.is_action || deviceData.disabled"
                    />
                </div>
            </v-flex>
        </v-layout>
        <v-flex d-flex justify-end>
            <div v-if="deviceData.is_action && deviceData.state" class="note-row">
                {{deviceData.state.last_update.slice(0, 16)}}
            </div>
        </v-flex>
    </div>
</template>

<script>
import { LOADING_TIMEOUT } from "@/utils/constants.js";
export default {
    name: "LightingDevice",
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceData: {},
            loading: false,
            disabledTimeout: null,
        };
    },
    created() {
        this.deviceData = this.device;
    },
    beforeDestroy() {
        if (this.disabledTimeout) {
            clearTimeout(this.disabledTimeout);
        }
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = val;
                this.loading = false;
                if (this.disabledTimeout) {
                    clearTimeout(this.disabledTimeout);
                    this.deviceData.disabled = false;
                }
            }
        },
    },
    methods: {
        changeDeviceState() {
            this.loading = true;
            this.deviceData.disabled = true;
            if (this.disabledTimeout) {
                clearTimeout(this.disabledTimeout);
            }
            this.disabledTimeout = setTimeout(() => {
                this.deviceData.disabled = false;
                this.loading = false;
                this.deviceData.state.value = this.deviceData.state ? !this.deviceData.state.value : null;
            }, LOADING_TIMEOUT);
            this.$http.put('/devices/guest/device/' + this.deviceData.uid + '/state', {
                value: this.deviceData.state.value
            })
                .catch((error) => {
                    if (this.disabledTimeout) {
                        clearTimeout(this.disabledTimeout);
                    }
                    this.deviceData.disabled = false;
                    this.deviceData.state.value = this.deviceData.state ? !this.deviceData.state.value : null;
                    this.loading = false;
                    console.log(error);
                });
        },
        openLightingHistory() {
            if (this.deviceData) {
                this.$router.push({ name: 'lightinghistory', params: {id: this.deviceData.uid} });
            }
        },
    },
}
</script>